var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5352 11.4272H11.4641V18.4983H18.5352V11.4272Z",
    fill: "#7C5CFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.81247 23.8018C10.2709 23.8018 11.4641 22.6086 11.4641 21.1502V18.4985H8.81247C7.35407 18.4985 6.16083 19.6918 6.16083 21.1502C6.16083 22.6086 7.35407 23.8018 8.81247 23.8018Z",
    fill: "#7C5CFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.81247 11.4273H11.4641V8.77566C11.4641 7.31726 10.2709 6.12402 8.81247 6.12402C7.35407 6.12402 6.16083 7.31726 6.16083 8.77566C6.16083 10.2341 7.35407 11.4273 8.81247 11.4273Z",
    fill: "#7C5CFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.5352 11.4273H21.1868C22.6452 11.4273 23.8384 10.2341 23.8384 8.77566C23.8384 7.31726 22.6452 6.12402 21.1868 6.12402C19.7284 6.12402 18.5352 7.31726 18.5352 8.77566V11.4273Z",
    fill: "#7C5CFC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.1868 23.8018C22.6452 23.8018 23.8384 22.6086 23.8384 21.1502C23.8384 19.6918 22.6452 18.4985 21.1868 18.4985H18.5352V21.1502C18.5352 22.6086 19.7284 23.8018 21.1868 23.8018Z",
    fill: "#7C5CFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15L15 10L10 15L15 20L20 15Z",
    fill: "#7C5CFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.37504 16.875C5.40628 17.9062 7.09378 17.9062 8.12502 16.875L10 15L8.12502 13.125C7.09378 12.0937 5.40628 12.0937 4.37504 13.125C3.34379 14.1562 3.34379 15.8437 4.37504 16.875Z",
    fill: "#7C5CFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.125 8.12498L15 9.99997L16.875 8.12498C17.9062 7.09373 17.9062 5.40624 16.875 4.37499C15.8437 3.34375 14.1563 3.34375 13.125 4.37499C12.0938 5.40624 12.0938 7.09373 13.125 8.12498Z",
    fill: "#7C5CFC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 15L21.875 16.875C22.9062 17.9062 24.5937 17.9062 25.625 16.875C26.6562 15.8437 26.6562 14.1562 25.625 13.125C24.5937 12.0937 22.9062 12.0937 21.875 13.125L20 15Z",
    fill: "#7C5CFC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.125 25.625C14.1563 26.6562 15.8437 26.6562 16.875 25.625C17.9062 24.5937 17.9062 22.9062 16.875 21.875L15 20L13.125 21.875C12.0938 22.9062 12.0938 24.5937 13.125 25.625Z",
    fill: "#7C5CFC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon);
export default __webpack_public_path__ + "static/media/footerIcon.d46a4d7ea996b63cf6cca071ecdc77a4.svg";
export { ForwardRef as ReactComponent };